module.exports = __webpack_public_path__ + "static/media/facilities-construction.a4a32a79.jpg";